import React, { Component } from "react";
import { Container, Form, Label, Input, FormGroup, Button } from "reactstrap";

import DefaultLayout from "../../components/layouts/defaultlayout/defaultlayout";
import { Validators, FormValidation } from "../../utils/formvalidation";
import FormError from "../../components/formerror/formerror";
import webService from "../../utils/webservice";
import history from "../../utils/history";
import config from "../../utils/config";
import eventsHub from "../../utils/eventshub";

class PageLogin extends Component {
  state = {
    passwordType: "password",
    form: null,
  };

  constructor(props) {
    super(props);

    let form = {
      // email: { value: config.loginUser, validations: [Validators.required, Validators.email] },
      // password: { value: config.loginPass, validations: [Validators.required, Validators.minLength(6)] },
      captcha: { value: "" },
      cuit: { value: config.cuit, validations: [Validators.required, Validators.cuit] },
      transaccion: { value: config.transaccion, validations: [Validators.required] },
      pais: { value: '', validations: [Validators.required] },
      nif: { value: '', validations: [Validators.required] },
    };
    this.formValidation = new FormValidation(form);
    this.state.form = this.formValidation.getClone();
  }

  showPassword(show) {
    this.setState({ passwordType: show ? "text" : "password" });
  }

  onFormHandleChange(name, value) {
    this.formValidation.setValue(name, value);
    this.setState({ form: this.formValidation.getClone() });
  }

  onFormHandleBlur(name) {
    this.formValidation.setTouched(name);
    this.setState({ form: this.formValidation.getClone() });
  }

  onFormHandleSubmit(event) {
    event.preventDefault();
    this.formValidation.checkForm(true);
    if (!this.formValidation.isValid()) {
      this.setState({ form: this.formValidation.getClone() });
      return;
    }

    let formValue = this.formValidation.getValue();
    //LOGIN USR y PASX
    // webService
    //   .login(formValue.email, formValue.password)
    //   .then(response => {
    webService
      .getEmpresaFicha(formValue.cuit, formValue.transaccion, formValue.pais, formValue.nif)
      .then(fichaEmpresa => {
        eventsHub.setFichaEmpresa(fichaEmpresa);
        history.push("/home");
      })
      .catch(error => {
        localStorage.clear();
        eventsHub.setLoggedIn(false);
        if (error.response && error.response.data) {
          alert(error.response.data.message);
        } else {
          alert("Error al comunicarse con el servidor");
        }
      });
    // })
    // .catch(error => {
    //   if (error.response && error.response.data) {
    //     alert(error.response.data.message);
    //   } else {
    //     alert("Error al comunicarse con el servidor");
    //   }
    // });
  }

  render() {
    return (
      <DefaultLayout showSidebar={false}>
        <Container>
          <div className="datos-box bg-white w-50 mx-auto my-5">
            <h2 className="mb-4">Ingreso</h2>
            <Form noValidate onSubmit={this.onFormHandleSubmit.bind(this)}>
              {/* <FormGroup>
                <Label>Email</Label>
                <Input
                  type="email"
                  value={this.state.form.email.value}
                  invalid={this.state.form.email.invalid}
                  onChange={event => this.onFormHandleChange("email", event.target.value)}
                  onBlur={() => this.onFormHandleBlur("email")}
                />
                <FormError errors={this.state.form.email.errors} />
              </FormGroup>
              <FormGroup>
                <Label>Contraseña</Label>
                <InputGroup>
                  <Input
                    type={this.state.passwordType}
                    value={this.state.form.password.value}
                    invalid={this.state.form.password.invalid}
                    onChange={event => this.onFormHandleChange("password", event.target.value)}
                    onBlur={() => this.onFormHandleBlur("password")}
                  />
                  <InputGroupAddon addonType="append">
                    <Button
                      type="button"
                      color="white"
                      onMouseDown={this.showPassword.bind(this, true)}
                      onMouseUp={this.showPassword.bind(this, false)}
                      onMouseLeave={this.showPassword.bind(this, false)}
                    >
                      <i className="fa fa-eye" />
                    </Button>
                  </InputGroupAddon>
                  <FormError errors={this.state.form.password.errors} />
                </InputGroup>
              </FormGroup> */}
              <FormGroup>
                <Label>CUIT</Label>
                <Input
                  type="text"
                  value={this.state.form.cuit.value}
                  invalid={this.state.form.cuit.invalid}
                  onChange={event => this.onFormHandleChange("cuit", event.target.value)}
                  onBlur={() => this.onFormHandleBlur("cuit")}
                />
                <FormError errors={this.state.form.cuit.errors} />
              </FormGroup>
              <FormGroup>
                <Label>Transacci&oacute;n</Label>
                <Input
                    type="text"
                    value={this.state.form.transaccion.value}
                    invalid={this.state.form.transaccion.invalid}
                    onChange={event => this.onFormHandleChange("transaccion", event.target.value)}
                    onBlur={() => this.onFormHandleBlur("transaccion")}
                  />
                  <FormError errors={this.state.form.transaccion.errors} />
              </FormGroup>
              <h4>Datos de la empresa vinculada</h4>
              <FormGroup>
                <Label>Residencia tributaria</Label>
                <Input
                    type="select"
                    value={this.state.form.pais.value}
                    invalid={this.state.form.pais.invalid}
                    onChange={event => this.onFormHandleChange("pais", event.target.value)}
                    onBlur={() => this.onFormHandleBlur("pais")}
                  >
                    <option value="101">101 - BURKINA FASO</option>
                    <option value="102">102 - ARGELIA</option>
                    <option value="103">103 - BOTSWANA</option>
                    <option value="104">104 - BURUNDI</option>
                    <option value="105">105 - CAMERUN</option>
                    <option value="107">107 - REP. CENTROAFRICANA.</option>
                    <option value="108">108 - CONGO</option>
                    <option value="109">109 - REP.DEMOCRAT.DEL CONGO EX ZAIRE</option>
                    <option value="110">110 - COSTA DE MARFIL</option>
                    <option value="111">111 - CHAD</option>
                    <option value="112">112 - BENIN</option>
                    <option value="113">113 - EGIPTO</option>
                    <option value="115">115 - GABON</option>
                    <option value="116">116 - GAMBIA</option>
                    <option value="117">117 - GHANA</option>
                    <option value="118">118 - GUINEA</option>
                    <option value="119">119 - GUINEA ECUATORIAL</option>
                    <option value="120">120 - KENYA</option>
                    <option value="121">121 - LESOTHO</option>
                    <option value="122">122 - LIBERIA</option>
                    <option value="123">123 - LIBIA</option>
                    <option value="124">124 - MADAGASCAR</option>
                    <option value="125">125 - MALAWI</option>
                    <option value="126">126 - MALI</option>
                    <option value="127">127 - MARRUECOS</option>
                    <option value="128">128 - MAURICIO,ISLAS</option>
                    <option value="129">129 - MAURITANIA</option>
                    <option value="130">130 - NIGER</option>
                    <option value="131">131 - NIGERIA</option>
                    <option value="132">132 - ZIMBABWE</option>
                    <option value="133">133 - RWANDA</option>
                    <option value="134">134 - SENEGAL</option>
                    <option value="135">135 - SIERRA LEONA</option>
                    <option value="136">136 - SOMALIA</option>
                    <option value="137">137 - SWAZILANDIA</option>
                    <option value="138">138 - SUDAN</option>
                    <option value="139">139 - TANZANIA</option>
                    <option value="140">140 - TOGO</option>
                    <option value="141">141 - TUNEZ</option>
                    <option value="142">142 - UGANDA</option>
                    <option value="143">143 - REPUBLICA DE SUDAFRICA</option>
                    <option value="144">144 - ZAMBIA</option>
                    <option value="145">145 - TERRIT.VINCULADOS AL R UNIDO</option>
                    <option value="146">146 - TERRIT.VINCULADOS A ESPAÑA</option>
                    <option value="147">147 - TERRIT.VINCULADOS A FRANCIA</option>
                    <option value="148">148 - TERRIT.VINCULADOS A PORTUGAL</option>
                    <option value="149">149 - ANGOLA</option>
                    <option value="150">150 - CABO VERDE</option>
                    <option value="151">151 - MOZAMBIQUE</option>
                    <option value="152">152 - SEYCHELLES</option>
                    <option value="153">153 - DJIBOUTI</option>
                    <option value="155">155 - COMORAS</option>
                    <option value="156">156 - GUINEA BISSAU</option>
                    <option value="157">157 - STO.TOME Y PRINCIPE</option>
                    <option value="158">158 - NAMIBIA</option>
                    <option value="159">159 - SUDAFRICA</option>
                    <option value="160">160 - ERITREA</option>
                    <option value="161">161 - ETIOPIA</option>
                    <option value="197">197 - RESTO (AFRICA)</option>
                    <option value="198">198 - INDETERMINADO (AFRICA)</option>
                    <option value="200">200 - ARGENTINA</option>
                    <option value="201">201 - BARBADOS</option>
                    <option value="202">202 - BOLIVIA</option>
                    <option value="203">203 - BRASIL</option>
                    <option value="204">204 - CANADA</option>
                    <option value="205">205 - COLOMBIA</option>
                    <option value="206">206 - COSTA RICA</option>
                    <option value="207">207 - CUBA</option>
                    <option value="208">208 - CHILE</option>
                    <option value="209">209 - DOMINICANA,REP.</option>
                    <option value="210">210 - ECUADOR</option>
                    <option value="211">211 - EL SALVADOR</option>
                    <option value="212">212 - ESTADOS UNIDOS</option>
                    <option value="213">213 - GUATEMALA</option>
                    <option value="214">214 - GUYANA</option>
                    <option value="215">215 - HAITI</option>
                    <option value="216">216 - HONDURAS</option>
                    <option value="217">217 - JAMAICA</option>
                    <option value="218">218 - MEXICO</option>
                    <option value="219">219 - NICARAGUA</option>
                    <option value="220">220 - PANAMA</option>
                    <option value="221">221 - PARAGUAY</option>
                    <option value="222">222 - PERU</option>
                    <option value="223">223 - PUERTO RICO</option>
                    <option value="224">224 - TRINIDAD Y -TOBAGO</option>
                    <option value="225">225 - URUGUAY</option>
                    <option value="226">226 - VENEZUELA</option>
                    <option value="227">227 - TERRIT.VINCULADO AL R.UNIDO</option>
                    <option value="228">228 - TER.VINCULADOS A DINAMARCA</option>
                    <option value="229">229 - TERRIT.VINCULADOS A FRANCIA AMERIC.</option>
                    <option value="230">230 - TERRIT. HOLANDESES</option>
                    <option value="231">231 - TER.VINCULADOS A ESTADOS UNIDOS</option>
                    <option value="232">232 - SURINAME</option>
                    <option value="233">233 - DOMINICA</option>
                    <option value="234">234 - SANTA LUCIA</option>
                    <option value="235">235 - SAN VICENTE Y LAS GRANADINS</option>
                    <option value="236">236 - BELICE</option>
                    <option value="237">237 - ANTIGUA Y BARBUDA</option>
                    <option value="238">238 - S.CRISTOBAL Y NEVIS</option>
                    <option value="239">239 - BAHAMAS</option>
                    <option value="240">240 - GRANADA</option>
                    <option value="241">241 - ANTILLAS HOLANDESAS</option>
                    <option value="242">242 - ARUBA</option>
                    <option value="250">250 - TIERRA DEL FUEGO</option>
                    <option value="251">251 - ZF LA PLATA</option>
                    <option value="252">252 - ZF JUSTO DARACT</option>
                    <option value="253">253 - ZF RIO GALLEGOS</option>
                    <option value="254">254 - ISLAS MALVINAS</option>
                    <option value="255">255 - ZF TUCUMAN</option>
                    <option value="256">256 - ZF CORDOBA</option>
                    <option value="257">257 - ZF MENDOZA</option>
                    <option value="258">258 - ZF GENERAL PICO</option>
                    <option value="259">259 - ZF COMODORO RIVADAVIA</option>
                    <option value="260">260 - ZF IQUIQUE</option>
                    <option value="261">261 - ZF PUNTA ARENAS</option>
                    <option value="262">262 - ZF SALTA</option>
                    <option value="263">263 - ZF PASO DE LOS LIBRES</option>
                    <option value="264">264 - ZF PUERTO IGUAZU</option>
                    <option value="265">265 - SECTOR ANTARTICO ARG.</option>
                    <option value="270">270 - ZF COLON</option>
                    <option value="271">271 - ZF WINNER (STA. C.DE LA SIERRA</option>
                    <option value="280">280 - ZF COLONIA</option>
                    <option value="281">281 - ZF FLORIDA</option>
                    <option value="282">282 - ZF LIBERTAD</option>
                    <option value="283">283 - ZF ZONAMERICA</option>
                    <option value="284">284 - ZF NUEVA HELVECIA</option>
                    <option value="285">285 - ZF NUEVA PALMIRA</option>
                    <option value="286">286 - ZF RIO NEGRO</option>
                    <option value="287">287 - ZF RIVERA</option>
                    <option value="288">288 - ZF SAN JOSE</option>
                    <option value="291">291 - ZF MANAOS</option>
                    <option value="295">295 - MAR ARG ZONA ECO.EX</option>
                    <option value="296">296 - RIOS ARG NAVEG INTER</option>
                    <option value="297">297 - RESTO AMERICA</option>
                    <option value="298">298 - INDETERMINADO.(AMERICA)</option>
                    <option value="301">301 - AFGANISTAN</option>
                    <option value="302">302 - ARABIA SAUDITA</option>
                    <option value="303">303 - BAHREIN</option>
                    <option value="304">304 - MYANMAR(EX-BIRMANIA)</option>
                    <option value="305">305 - BUTAN</option>
                    <option value="306">306 - CAMBODYA(EX-KAMPUCHE</option>
                    <option value="307">307 - SRI LANKA</option>
                    <option value="308">308 - COREA DEMOCRATICA</option>
                    <option value="309">309 - COREA REPUBLICANA</option>
                    <option value="310">310 - CHINA</option>
                    <option value="311">311 - CHIPRE</option>
                    <option value="312">312 - FILIPINAS</option>
                    <option value="313">313 - TAIWAN</option>
                    <option value="314">314 - GAZA</option>
                    <option value="315">315 - INDIA</option>
                    <option value="316">316 - INDONESIA</option>
                    <option value="317">317 - IRAK</option>
                    <option value="318">318 - IRAN</option>
                    <option value="319">319 - ISRAEL</option>
                    <option value="320">320 - JAPON</option>
                    <option value="321">321 - JORDANIA</option>
                    <option value="322">322 - QATAR</option>
                    <option value="323">323 - KUWAIT</option>
                    <option value="324">324 - LAOS</option>
                    <option value="325">325 - LIBANO</option>
                    <option value="326">326 - MALASIA</option>
                    <option value="327">327 - MALDIVAS ISLAS</option>
                    <option value="328">328 - OMAN</option>
                    <option value="329">329 - MONGOLIA</option>
                    <option value="330">330 - NEPAL</option>
                    <option value="331">331 - EMIRATOS ARABES,UNID</option>
                    <option value="332">332 - PAKISTAN</option>
                    <option value="333">333 - SINGAPUR</option>
                    <option value="334">334 - SIRIA</option>
                    <option value="335">335 - THAILANDIA</option>
                    <option value="336">336 - TURQUIA</option>
                    <option value="337">337 - VIETNAM</option>
                    <option value="341">341 - HONG KONG</option>
                    <option value="344">344 - MACAO</option>
                    <option value="345">345 - BANGLADESH</option>
                    <option value="346">346 - BRUNEI</option>
                    <option value="348">348 - REPUBLICA DE YEMEN</option>
                    <option value="349">349 - ARMENIA</option>
                    <option value="350">350 - AZERBAIJAN</option>
                    <option value="351">351 - GEORGIA</option>
                    <option value="352">352 - KAZAJSTAN</option>
                    <option value="353">353 - KIRGUIZISTAN</option>
                    <option value="354">354 - TAYIKISTAN</option>
                    <option value="355">355 - TURKMENISTAN</option>
                    <option value="356">356 - UZBEKISTAN</option>
                    <option value="357">357 - TERR. AU. PALESTINOS</option>
                    <option value="358">358 - TIMOR ORIENTAL</option>
                    <option value="397">397 - RESTO DE ASIA</option>
                    <option value="398">398 - INDET.(ASIA)</option>
                    <option value="401">401 - ALBANIA</option>
                    <option value="402">402 - ALEMANIA FEDERAL</option>
                    <option value="403">403 - ALEMANIA ORIENTAL</option>
                    <option value="404">404 - ANDORRA</option>
                    <option value="405">405 - AUSTRIA</option>
                    <option value="406">406 - BELGICA</option>
                    <option value="407">407 - BULGARIA</option>
                    <option value="408">408 - CHECOSLOVAQUIA</option>
                    <option value="409">409 - DINAMARCA</option>
                    <option value="410">410 - ESPAÑA</option>
                    <option value="411">411 - FINLANDIA</option>
                    <option value="412">412 - FRANCIA</option>
                    <option value="413">413 - GRECIA</option>
                    <option value="414">414 - HUNGRIA</option>
                    <option value="415">415 - IRLANDA</option>
                    <option value="416">416 - ISLANDIA</option>
                    <option value="417">417 - ITALIA</option>
                    <option value="418">418 - LIECHTENSTEIN</option>
                    <option value="419">419 - LUXEMBURGO</option>
                    <option value="420">420 - MALTA</option>
                    <option value="421">421 - MONACO</option>
                    <option value="422">422 - NORUEGA</option>
                    <option value="423">423 - PAISES BAJOS</option>
                    <option value="424">424 - POLONIA</option>
                    <option value="425">425 - PORTUGAL</option>
                    <option value="426">426 - REINO UNIDO</option>
                    <option value="427">427 - RUMANIA</option>
                    <option value="428">428 - SAN MARINO</option>
                    <option value="429">429 - SUECIA</option>
                    <option value="430">430 - SUIZA</option>
                    <option value="431">431 - VATICANO(SANTA SEDE)</option>
                    <option value="432">432 - YUGOSLAVIA</option>
                    <option value="433">433 - POS.BRIT.(EUROPA)</option>
                    <option value="434">434 - HOLANDA</option>
                    <option value="435">435 - CHIPRE</option>
                    <option value="436">436 - TURQUIA</option>
                    <option value="438">438 - ALEMANIA,REP.FED.</option>
                    <option value="439">439 - BIELORRUSIA</option>
                    <option value="440">440 - ESTONIA</option>
                    <option value="441">441 - LETONIA</option>
                    <option value="442">442 - LITUANIA</option>
                    <option value="443">443 - MOLDAVIA</option>
                    <option value="444">444 - RUSIA</option>
                    <option value="445">445 - UCRANIA</option>
                    <option value="446">446 - BOSNIA HERZEGOVINA</option>
                    <option value="447">447 - CROACIA</option>
                    <option value="448">448 - ESLOVAQUIA</option>
                    <option value="449">449 - ESLOVENIA</option>
                    <option value="450">450 - MACEDONIA</option>
                    <option value="451">451 - REP. CHECA</option>
                    <option value="452">452 - FED. SER Y MONT YOGOE</option>
                    <option value="453">453 - MONTENEGRO</option>
                    <option value="454">454 - SERBIA</option>
                    <option value="497">497 - RESTO EUROPA</option>
                    <option value="498">498 - INDET.(EUROPA)</option>
                    <option value="501">501 - AUSTRALIA</option>
                    <option value="503">503 - NAURU</option>
                    <option value="504">504 - NUEVA ZELANDIA</option>
                    <option value="505">505 - VANATU</option>
                    <option value="506">506 - SAMOA OCCIDENTAL</option>
                    <option value="507">507 - TERRITORIO VINCULADOS A AUSTRALIA</option>
                    <option value="508">508 - TERRITORIOS VINCULADOS AL R. UNIDO</option>
                    <option value="509">509 - TERRITORIOS VINCULADOS A FRANCIA</option>
                    <option value="510">510 - TER VINCULADOS A NUEVA. ZELANDA</option>
                    <option value="511">511 - TER. VINCULADOS A ESTADOS UNIDOS</option>
                    <option value="512">512 - FIJI, ISLAS</option>
                    <option value="513">513 - PAPUA NUEVA GUINEA</option>
                    <option value="514">514 - KIRIBATI, ISLAS</option>
                    <option value="515">515 - MICRONESIA,EST.FEDER</option>
                    <option value="516">516 - PALAU</option>
                    <option value="517">517 - TUVALU</option>
                    <option value="518">518 - SALOMON,ISLAS</option>
                    <option value="519">519 - TONGA</option>
                    <option value="520">520 - MARSHALL,ISLAS</option>
                    <option value="521">521 - MARIANAS,ISLAS</option>
                    <option value="597">597 - RESTO OCEANIA</option>
                    <option value="598">598 - INDET.(OCEANIA)</option>
                    <option value="601">601 - URSS</option>
                    <option value="652">652 - ANGUILA (TERRITORIO NO AUTONOMO DEL R. UNIDO)</option>
                    <option value="659">659 - ANTILLAS HOLANDESAS (TERRITORIO DE PAISES BAJOS)</option>
                    <option value="653">653 - ARUBA (TERRITORIO DE PAISES BAJOS)</option>
                    <option value="662">662 - ASCENCION</option>
                    <option value="663">663 - BERMUDAS (TERRITORIO NO AUTONOMO DEL R UNIDO)</option>
                    <option value="664">664 - CAMPIONE DITALIA</option>
                    <option value="665">665 - COLONIA DE GIBRALTAR</option>
                    <option value="666">666 - GROENLANDIA</option>
                    <option value="667">667 - GUAM (TERRITORIO NO AUTONOMO DE LOS ESTADO UNIDOS</option>
                    <option value="668">668 - HONG KONG (TERRITORIO DE CHINA)</option>
                    <option value="669">669 - ISLAS AZORES</option>
                    <option value="670">670 - ISLAS DEL CANAL (GUERNESEY, JERSEY, ALDERNEY,G.STARK, L.SARK, ETC)</option>
                    <option value="671">671 - ISLAS CAIMAN (TERRITORIO NO AUTONOMO DE R UNIDO)</option>
                    <option value="672">672 - ISLA CHRISTMAS</option>
                    <option value="673">673 - ISLA DE COCOS O KEELING</option>
                    <option value="654">654 - ISLA DE COOK (TERRITORIO AUTONOMO ASOCIADO A NUEVA ZELANDA)</option>
                    <option value="676">676 - ISLA DE MAN (TERRITORIO DEL REINO UNIDO)</option>
                    <option value="677">677 - ISLA DE NORFOLK (TERRITORIO DEL R UNIDO)</option>
                    <option value="678">678 - ISALAS TURKAS Y CAICOS (TERRITORIO NO AUTONOMO DEL REINO UNIDO)</option>
                    <option value="679">679 - ISLAS PACIFICO</option>
                    <option value="680">680 - ISLAS DE SAN PEDRO Y MIGUELON</option>
                    <option value="681">681 - ISLA QESHM</option>
                    <option value="682">682 - ISLAS VIRGENES BRITANICAS (TERRITORIO NO AUTONOMO DEL REINO UNIDO)</option>
                    <option value="683">683 - ISLAS VIRGENES DE ESTADOS UNIDOS DE AMERICA</option>
                    <option value="684">684 - LABUAM</option>
                    <option value="685">685 - MADEIRA (TERRITORIO DE PORTUGAL)</option>
                    <option value="686">686 - MONSERRAT (TERRITORIO NO AUTONOMO DEL REINO UNIDO)</option>
                    <option value="687">687 - NIUE </option>
                    <option value="655">655 - PATAU</option>
                    <option value="690">690 - PITCAIRN</option>
                    <option value="656">656 - POLINESI FRANCESA (TERRITORIO DE ULTRAMAR DE FRANCIA)</option>
                    <option value="693">693 - REGIMEN APLICABLE A LAS SA FINANCIERAS (LEY 11073 DE LA ROU)</option>
                    <option value="694">694 - SANTA ELENA</option>
                    <option value="695">695 - SAMAO AMERICANA (TERRITORIO NO AUTONOMO DE LOS ESTADOS UNIDOS)</option>
                    <option value="696">696 - ARCHIPIELAGO DE SVBALBARD</option>
                    <option value="697">697 - TRISTAN DACUNHA</option>
                    <option value="698">698 - TRIESTE (ITALIA)</option>
                    <option value="699">699 - TOKELAU</option>
                    <option value="700">700 - ZONA LIBRE DE OSTRAVA (CIUDAD DE LA ATIGUA CHECOSLOVAQUIA)</option>
                    <option value="997">997 - RESTO CONTINENTE</option>
                    <option value="998">998 - INDET.(CONTINENTE)</option>
                    <option value="999">999 - OTROS PAISES</option>
                  </Input>
                  <FormError errors={this.state.form.pais.errors} />
              </FormGroup>
              <FormGroup>
                <Label>Código de identificación tributaria</Label>
                <Input
                    type="text"
                    value={this.state.form.nif.value}
                    invalid={this.state.form.nif.invalid}
                    onChange={event => this.onFormHandleChange("nif", event.target.value)}
                    onBlur={() => this.onFormHandleBlur("nif")}
                  />
                  <FormError errors={this.state.form.nif.errors} />
              </FormGroup>

              <div className="text-center">
                <Button type="submit" color="success" className="my-4">
                  INICI&Aacute; SESI&Oacute;N
                </Button>
              </div>
            </Form>
          </div>
        </Container>
      </DefaultLayout>
    );
  }
}

export default PageLogin;
